<template>
  <div>
    <b-form @submit.prevent="saveSettings" v-if="!fetching">
      <b-row class="manager-affiliate-setting">
        <b-col sm="12" lg="12" style="padding: 0" class="affiliate-setting">
          <b-card class="mb-4 affiliate-setting-card">
            <b-card-body class="affiliate-setting-form-card-body p-0">
              <div class="container affiliate-setting-container">
                <div class="row mb-3">
                  <div class="col-md-12">
                    <span style="font-weight: semi-bold; font-size: 20pt">{{ __('Affiliate Settings') }}</span>
                  </div>
                </div>
                <hr class="mt-1" />
                <div class="col-md-12 affiliate-setting-form">
                  <b-form-group>
                    <b-row class="mb-1">
                      <div class="col-md-2">
                        <label class="form-title d-inline-block w-100 pt-2">
                          {{ __('Commission Type') }}
                          <span class="required">*</span>
                        </label>
                      </div>
                      <div class="col-md-7 col-sm-12">
                        <v-select
                          :options="possibleCommissionTypes"
                          v-model="setting.commission_type"
                          :placeholder="__('Select commission type...')"
                        >
                        </v-select>
                      </div>
                    </b-row>
                  </b-form-group>
                  <b-form-group>
                    <b-row class="mb-1">
                      <div class="col-md-2">
                        <label class="form-title d-inline-block w-100 pt-2">
                          {{ __('Commission Amount') }}
                          <span class="required">*</span>
                        </label>
                      </div>
                      <div class="col-md-7 col-sm-12">
                        <b-form-input
                          class="form-control"
                          v-model="setting.commission_amount"
                          :placeholder="__('Enter commission amount...')"
                        ></b-form-input>
                      </div>
                    </b-row>
                  </b-form-group>

                  <b-row>
                    <b-col sm="12" class="text-center mt-5 mb-3">
                      <b-button type="submit" variant="primary">
                        <span>{{ __('Save') }}</span>
                      </b-button>
                    </b-col>
                  </b-row>

                  <b-alert :variant="success ? 'success' : 'danger'" v-if="message" show>
                    {{ message }}
                  </b-alert>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
const possibleCommissionTypes = ['flat', 'percentage'];

import axios from 'axios';
export default {
  data() {
    return {
      fetching: false,
      success: false,
      message: '',
      settingId: 0,
      setting: {
        commission_type: '',
        commission_amount: '',
      },
    };
  },

  computed: {
    possibleCommissionTypes() {
      return possibleCommissionTypes;
    },
  },

  async mounted() {
    await this.fetchSetting();
  },

  methods: {
    async fetchSetting() {
      this.fetching = true;

      try {
        let response = await axios.get('/api/settings/showbyname/affiliate');
        let settings = response.data.data;
        this.settingId = settings.id;
        this.setting = settings.value;
      } catch (err) {
      } finally {
        this.fetching = false;
      }
    },

    async saveSettings() {
      let postData = {
        value: JSON.stringify(this.setting),
      };

      try {
        let response = await axios.put(`/api/settings/${this.settingId}`, postData);
        this.success = response.data.success;
        this.message = response.data.message;
      } catch (err) {
        this.success = false;
        this.message = err.response.data.message;
      }
    },
  },
};
</script>

<style>
.layout-sidebar-large .main-content-wrap {
  background-image: url('@/assets/images/form/form-bg-orange.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-position: center;
}

.affiliate-setting-container {
  padding: 0;
}

@media only screen and (max-width: 360px) {
  .affiliate-setting-card-body,
  .affiliate-setting-container {
    padding: 0;
  }

  .affiliate-setting-card {
    width: 285px;
  }

  .affiliate-setting-form {
    padding: 0;
  }

  .layout-sidebar-large .main-content-wrap {
    padding-right: 10px;
  }
}

@media only screen and (max-width: 600px) {
  .manager-affiliate-setting {
    width: 113% !important;
  }
}
</style>
